const DROP_TAGS = new Set([
  'script',
  'iframe',
  'object',
  'embed',
  'link',
  'meta',
  'base',
  'form',
  'svg',
  'math',
  'frame',
  'frameset',
  'applet',
]);

function isSafeUrl(value: string): boolean {
  const normalized = value.replace(/[\u0000-\u0020]+/g, '').toLowerCase();
  return !normalized.startsWith('javascript:')
    && !normalized.startsWith('vbscript:')
    && !normalized.startsWith('data:');
}

function sanitizeElement(element: Element): void {
  for (const child of Array.from(element.children)) {
    if (DROP_TAGS.has(child.tagName.toLowerCase())) {
      child.remove();
      continue;
    }

    for (const attribute of Array.from(child.attributes)) {
      const name = attribute.name.toLowerCase();
      if (name.startsWith('on') || name === 'srcdoc') {
        child.removeAttribute(attribute.name);
        continue;
      }
      if ((name === 'href' || name === 'src' || name === 'xlink:href') && !isSafeUrl(attribute.value)) {
        child.removeAttribute(attribute.name);
        continue;
      }
      if (name === 'style' && /expression\s*\(|javascript\s*:|vbscript\s*:|-moz-binding|url\s*\(\s*['"]?\s*javascript/i.test(attribute.value)) {
        child.removeAttribute(attribute.name);
      }
    }

    sanitizeElement(child);
  }
}

/** Strip script, event handlers, and dangerous URLs before rendering stored HTML. */
export function sanitizeHtml(html: string | null | undefined): string {
  if (!html || typeof DOMParser === 'undefined') {
    return '';
  }

  const document = new DOMParser().parseFromString(`<div id="sanitizer-root">${html}</div>`, 'text/html');
  const root = document.getElementById('sanitizer-root');
  if (!root) {
    return '';
  }

  sanitizeElement(root);
  return root.innerHTML;
}
